// Tjenestelista fra Ascendly (Convex), hentet paa serveren.
//
// Nettsidens sider bruker `useQuery` i nettleseren, men serverkode (loaderen
// for /tjenester/$slug og sitemapet) har ingen React-klient. Derfor snakker
// denne med Convex sitt HTTP-API direkte med fetch, paa samme maate som
// src/lib/synlig.ts gjoer for bloggen. Samme query som sidene bruker, saa
// server og nettleser ser alltid den samme lista.
import { BUSINESS_ID } from "./convex";
import type { LiveServiceRow } from "./site";

const CONVEX_URL = "https://bold-pony-700.eu-west-1.convex.cloud";

export async function hentLiveTjenester(): Promise<LiveServiceRow[]> {
  const res = await fetch(`${CONVEX_URL}/api/query`, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify({
      path: "bookings:listServicesForBusiness",
      format: "json",
      args: { businessId: BUSINESS_ID },
    }),
  });
  const json = await res.json();
  if (json.status === "error") throw new Error(json.errorMessage);
  return (json.value ?? []) as LiveServiceRow[];
}
